import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Message,
  ButtonContainer,
  RejectButton,
  AcceptButton,
} from './Styles';

export const FloorBidderBadgeValidation = ({
  decisionText,
  handleReject,
  handleProceed,
}) => (
  <Container>
    <Message>
      It does not appear that the Floor Bidder badge id has been registered or
      has been entered incorrectly. Would you like to fix or proceed using
      this badge id?
    </Message>
    <ButtonContainer>
      <RejectButton onClick={handleReject}>
        <i className="fa fa-times-circle-o fa-2" aria-hidden="true" />
        No, I&apos;ll Fix It
      </RejectButton>
      <AcceptButton onClick={handleProceed}>
        <i className="fa fa-check-circle-o fa-2" aria-hidden="true" />
        Proceed
        {' '}
        {decisionText}
      </AcceptButton>
    </ButtonContainer>
  </Container>
);

FloorBidderBadgeValidation.propTypes = {
  decisionText: PropTypes.string.isRequired,
  handleReject: PropTypes.func.isRequired,
  handleProceed: PropTypes.func.isRequired,
};

export default FloorBidderBadgeValidation;
